import { useIntl, defineMessages } from 'react-intl'
import { isValidName } from 'msp-integrations'
import { FieldsConfiguration } from 'msp-components'

const messages = defineMessages({
  firstName: {
    id: 'cancellation_form.label.first_name',
    defaultMessage: 'First name'
  },
  lastName: {
    id: 'cancellation_form.label.last_name',
    defaultMessage: 'Last name'
  },
  orderNumber: {
    id: 'cancellation_form.label.order_number',
    defaultMessage: 'Order number'
  },
  email: {
    id: 'cancellation_form.label.email',
    defaultMessage: 'Email address'
  },
  description: {
    id: 'cancellation_form.label.description',
    defaultMessage: 'Affected items / cancellation notes (optional)'
  },
  requiredFirstName: {
    id: 'cancellation_form.error.required_first_name',
    defaultMessage: 'Please enter your first name.'
  },
  requiredLastName: {
    id: 'cancellation_form.error.required_last_name',
    defaultMessage: 'Please enter your last name.'
  },
  requiredOrderNumber: {
    id: 'cancellation_form.error.required_order_number',
    defaultMessage: 'Please enter your order number.'
  },
  invalidOrderNumber: {
    id: 'cancellation_form.error.invalid_order_number',
    defaultMessage: 'Please enter a valid order number.'
  },
  requiredEmail: {
    id: 'cancellation_form.error.required_email',
    defaultMessage: 'Please enter your email address.'
  },
  invalidEmail: {
    id: 'cancellation_form.error.invalid_email',
    defaultMessage: 'Please enter a valid email address.'
  },
  invalidName: {
    id: 'cancellation_form.error.invalid_name',
    defaultMessage: 'Field contains invalid characters.'
  }
})

const EMAIL_PATTERN = new RegExp(
  '^(([^<>()[\\]\\\\.,;:\\s@"]+(\\.[^<>()[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
  'i'
)

const getCancellationFields = (): FieldsConfiguration => {
  const { formatMessage } = useIntl()
  return {
    firstName: {
      id: 'firstName',
      name: 'firstName',
      type: 'text',
      label: formatMessage(messages.firstName),
      autoComplete: 'given-name',
      maxLength: 40,
      rules: {
        required: formatMessage(messages.requiredFirstName) as string,
        validate: (value) =>
          isValidName(value) || (formatMessage(messages.invalidName) as string)
      }
    },
    lastName: {
      id: 'lastName',
      name: 'lastName',
      type: 'text',
      label: formatMessage(messages.lastName),
      autoComplete: 'family-name',
      maxLength: 80,
      rules: {
        required: formatMessage(messages.requiredLastName) as string,
        validate: (value) =>
          isValidName(value) || (formatMessage(messages.invalidName) as string)
      }
    },
    orderNumber: {
      id: 'orderNumber',
      name: 'orderNumber',
      type: 'text',
      label: formatMessage(messages.orderNumber),
      maxLength: 255,
      rules: {
        required: formatMessage(messages.requiredOrderNumber) as string,
        pattern: {
          value: /^[0-9]{6,}$/,
          message: formatMessage(messages.invalidOrderNumber) as string
        }
      }
    },
    email: {
      id: 'email',
      name: 'email',
      type: 'email',
      label: formatMessage(messages.email),
      autoComplete: 'email',
      maxLength: 80,
      rules: {
        required: formatMessage(messages.requiredEmail) as string,
        pattern: {
          value: EMAIL_PATTERN,
          message: formatMessage(messages.invalidEmail) as string
        }
      }
    },
    description: {
      id: 'description',
      name: 'description',
      type: 'textarea',
      label: formatMessage(messages.description),
      rows: 4,
      cols: 200,
      maxLength: 2000,
      resizeable: true
    }
  }
}

export default getCancellationFields
